import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Card } from 'antd';
import classes from "../CSS/carousal.module.css";
import pg1 from "../assets/pg1.png";

const { Meta } = Card;

const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 3
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 750 },
      items: 3
    },
    mobile: {
      breakpoint: { max: 700, min: 0 },
      items: 2
    }
  };
const Carousal =()=>{
    return(
        <>
           <div className={classes.ContainerDiv} className="container">
           <Carousel 
           
           autoPlay={true}
           showDots={true}
           autoPlaySpeed={2000}
           infinite={true}
           responsive={responsive}>
                <div>
                <Card
                        hoverable
                        style={{marginBottom:50}}
                        className={classes.Card}
                        cover={<img alt="example" src={pg1} />}
                    >
                        <Meta title="The Accelerator Program" description="Season 1 (2020)" />
                    </Card>
                </div>
                <div>
                <Card
                        hoverable
                        style={{marginBottom:50}}
                        className={classes.Card}
                        cover={<img alt="example" src={pg1} />}
                    >
                        <Meta title="The Accelerator Program" description="Season 1 (2020)" />
                    </Card>
                </div>
                <div>
                <Card
                        hoverable
                        style={{marginBottom:50}}
                        className={classes.Card}
                        cover={<img alt="example" src= {pg1} />}
                    >
                        <Meta title="The Accelerator Program" description="Season 1 (2020)" />
                    </Card>
                </div>
                
            </Carousel><br/><br/>
           </div>
        </>
    )
}
export default Carousal;